import styled from 'styled-components';
import { applyOpacity } from '../../../utils/color.utils';
import { vars } from '../../../theme';
import spacing from '../../../styles/spacing';

const invertedPrimary = vars.colors.text.invertedPrimary;

export const WidgetWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: ${spacing[12]};
    border-radius: ${vars.radius.sm};
    border: 1px solid ${applyOpacity(invertedPrimary, 18)};
    background: ${applyOpacity(invertedPrimary, 8)};
`;
